export default () => ({
  registerData: {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    smartcode: '',
  },
})
